import { c as e } from "../../../index-34b1f277.js";
import { PaginationAnatomy as i } from "./Pagination.anatomy.es.js";
const { defineMultiStyleConfig: t, definePartsStyle: n } = e(
  i.keys
), a = n({
  container: {
    display: "flex",
    paddingY: "spacing-300",
    gap: "spacing-300"
  },
  items: {
    display: "flex",
    gap: "spacing-125",
    alignItems: "center"
  }
}), l = t({
  baseStyle: a
});
export {
  l as Pagination
};
//# sourceMappingURL=Pagination.es.js.map
